import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=afde887e&scoped=true&"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=afde887e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde887e",
  null
  
)

export default component.exports